// Promo service for API calls
import { PromoCodeResponse } from '../types';
import { fetchWithErrorHandling, guestPrefix } from './apiUtils';

export class PromoService {
  static async getUserPromos(): Promise<PromoCodeResponse> {
    try {
      // Try API first
      try {
        const endpoint = `/api/v2${guestPrefix()}/users/me/promos`;
        return await fetchWithErrorHandling<PromoCodeResponse>(endpoint);
      } catch (apiError) {
        console.warn('API not available, falling back to local data:', apiError);

        // Fall back to local JSON file
        try {
          const { default: localPromoData } = await import('../data/promos.sample.data.json');
          return localPromoData as PromoCodeResponse;
        /* c8 ignore start */
        } catch (localError) {
          console.error('Failed to load local promo data:', localError);
          throw new Error('Unable to load promo data from both API and local data.');
        }
        /* c8 ignore stop */
      }
    /* c8 ignore start */
    } catch (error) {
      console.error('Failed to fetch promo data:', error);
      throw new Error('Unable to load promo data. Please try again later.');
    }
    /* c8 ignore stop */
  }
}
